import { TraitRegistry, TraitType } from '../../trait-registry';
import { Trait } from '../../trait.type';
import { AmmoType } from '../../ammo.type';
import type { ModifierParams } from '../../modifier.type';
import { StatusEffect } from '../../status-effects.type';

export class ArbelistTrait extends Trait {
  static baseType = TraitType.Arbelist;
  static baseTitle = 'Arbelist';
  static baseText =
    'When gaining Ammo (Basic), instead gain Ammo (Heavy). When gaining Ammo (Heavy), instead gain Ammo (Silver)';
  static baseIcon = 'trait';

  type = ArbelistTrait.baseType;
  title = ArbelistTrait.baseTitle;
  text = ArbelistTrait.baseText;
  icon = ArbelistTrait.baseIcon;

  modifierAdd(type: StatusEffect, stacks: number, params: ModifierParams): number {
    if (type == StatusEffect.Ammo && params.ammoType == AmmoType.Blank) {
      params.ammoType = AmmoType.Fist;
    } else if (type == StatusEffect.Ammo && params.ammoType == AmmoType.Fist) {
      params.ammoType = AmmoType.Silver;
    }
    return stacks;
  }
}

TraitRegistry.register(ArbelistTrait.baseType, ArbelistTrait);
